var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Access phpMyAdmin ")]),
      _c(
        "gg-card-text",
        [
          _c("p", [
            _vm._v(
              " You can use phpMyAdmin to access and manage all of your databases, run queries and other database management commands directly. "
            )
          ]),
          _c(
            "gg-btn",
            {
              attrs: {
                primary: ""
              },
              on: {
                click: function click($event) {
                  return _vm.launch_phpmyadmin(
                    _vm.hostingid,
                    _vm.$route.query.user
                  )
                }
              }
            },
            [
              _vm._v(" Launch phpMyAdmin "),
              _c(
                "v-icon",
                {
                  staticClass: "pl-2",
                  attrs: {
                    small: ""
                  }
                },
                [_vm._v(" mdi-open-in-new ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }